import React from 'react';
import { useTranslation } from 'react-i18next';
import css from '@shared/ui/input-error-message/styles/InputErrorMessageStyles.module.css';
import cn from 'classnames';

interface Props {
  error: React.ReactNode;
  className?: string;
  onDismiss?: () => void;
}

export const InputErrorMessage: React.FC<Props> = ({ error, className, onDismiss }) => {
  const { t } = useTranslation();

  if (!error) return null;

  return (
    <div className={cn(css.errorMessage, onDismiss && css.errorRow, className ? className : '')}>
      <span>{error}</span>
      {onDismiss ? (
        <button type="button" className={css.dismiss} onClick={onDismiss} aria-label={String(t('dismiss'))}>
          ×
        </button>
      ) : null}
    </div>
  );
};
